// extracted by mini-css-extract-plugin
module.exports = {"Loader3dContainer":"loader3d-module__Loader3dContainer","color-loading":"loader3d-module__color-loading"};